module.exports = __webpack_public_path__ + "img/intro_pc_img01_2.040b2ab4.png";